import { Button, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import colors from '../../../../assets/theme/base/colors';
import { CustomDialogTitle } from "../../../Common/Custom/CustomDialogTitle";
const { dark } = colors;

interface IProps {
    showWelcomeModal: boolean;
    closeWelcomeModal: () => void;
}

export const WelcomeModal = (props: IProps) => {
    return (
        <Dialog disableEnforceFocus open={props.showWelcomeModal} onClose={() => { props.closeWelcomeModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.closeWelcomeModal}>Welcome to your new audit platform</CustomDialogTitle>

            <DialogContent sx={{ width: '800px' }}>
                <img
                    src={`${process.env.PUBLIC_URL}/img/Welcome.svg`}
                    style={{ maxWidth: '100%', marginTop: '10px' }}>
                </img>
                <Grid container paddingTop={1} >
                    <MDTypography variant='subtitle2' width="100%">
                        Capture your B-BBEE claims and supporting documents in a secure environment.
                        Track the progress of the verification process and communicate directly with your verification analyst.
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' fontWeight='bold' width="100%" textAlign="center">
                        What you need to do:
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <ol style={{ color: dark.main }}>
                        <li>
                            <MDTypography variant='subtitle2'>
                                Select the <strong>Verification Planner & Tracker</strong> icon for your current scorecard.
                                This tracker informs you of the current status of the verification process and will remain empty until
                                the verification plan has been created by your verification analyst.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                Expand the navigation sidebar and select the <strong>Import Management</strong> item, then the <strong>File Management</strong> sub-item,
                                where you can upload your completed data gathering claims sheet if you require assistance with importing your data.
                                Alternatively, select the <strong>Import Data</strong> sub-item to directly import the data yourself and
                                choose the sheets and file you'd like to import.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                After importing your claims, select the <strong>View Checklist</strong> button to navigate to the <strong>Elements</strong> tab
                                where you can track the progress per element (or area) of your scorecard. Please review and submit your claims after clicking
                                the <strong>Action Icon</strong> in <strong>Step 1</strong> of (each area within) each element.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                Upload general supporting documents after clicking the <strong>Action Icon</strong> in <strong>Step 2</strong> of (each area within) each element.
                            </MDTypography>
                        </li>
                    </ol>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' fontWeight='bold' width="100%" textAlign="center" >
                        Next steps:
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%">
                        Your verification analyst will select a sample of your submitted claims.
                        Navigate to the <strong>Elements</strong> tab again and select the <strong>Action Icon</strong> in <strong>Step 3</strong> of (each area within) each element
                        to view sampled claims with a list of the relevant supporting documents to be uploaded.
                    </MDTypography>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={() => props.closeWelcomeModal()}>
                    Get started
                </Button>
            </DialogActions>
        </Dialog>
    )
}
